package org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.delete_furniture


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class DeleteFurnitureModel(
    @SerialName("data")
    val `data`: Data?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)